import { useMutation } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { StartExperimentMutation, StartExperimentMutationVariables } from './__generated__/StartExperimentMutation';
import { START_EXPERIMENT_MUTATION } from './startExperiment.mutation';

interface Props {
  onError: (errors: string[]) => void;
}

export function useStartExperimentMutation({ onError }: Props) {
  return useMutation<StartExperimentMutation, StartExperimentMutationVariables>(START_EXPERIMENT_MUTATION, {
    client: kmsClient,
    refetchQueries: ['ExperimentsQuery'],
    onError: (error) => onError([error.message]),
    onCompleted: (data) => {
      if (data?.startExperiment?.errors) {
        onError(data.startExperiment.errors);
      }
    }
  });
}
